import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

import '../../styling/dialog.css'
import { strings } from "../../strings"

const LimitDialog = ({open, closeDialog, limit, title}) => {

    let w = window.innerWidth
    let h = window.innerHeight

    return (
        <Dialog className="limit-dialog" open={open}>
            <DialogTitle style={{ width: `${w > h ? '30vw' : '65vw'}` }} >{title}</DialogTitle>
            <DialogContent >
                <DialogContentText>
                    {limit}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-actions">
                <span className="confirm-dialog" onClick={closeDialog} color="secondary" style={{ cursor: "pointer" }}>
                    {strings.dialogs.ok}
                </span>
            </DialogActions>
        </Dialog>
    )
}

export default LimitDialog
